const selectors = {
  accordion: '[data-partners-accordion]',
  accordionHeader: '[data-partners-accordion-header]',

  active: 'active',
}

const initPartnerAccordions = () => {
  const accordions = document.querySelectorAll(selectors.accordion)

  accordions?.forEach((accordion) => {
    const header = accordion.querySelector(selectors.accordionHeader)

    header?.addEventListener('click', () => accordion.classList.toggle(selectors.active))
  })
}

export default initPartnerAccordions
